/* Google Maps links for the admin. Plain URLs -- no API key involved. */

/*
 * Coordinates off any of the shapes the backend sends. Addresses carry both the
 * correct spellings and the legacy `lattitude` / `longitute` ones, and decimal
 * fields arrive as strings.
 */
export const toLatLng = (source) => {
  if (!source) return null;
  const lat = Number(source.latitude ?? source.lattitude ?? source.lat);
  const lng = Number(source.longitude ?? source.longitute ?? source.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  // 0,0 is what an unset decimal field turns into, not a real address.
  if (lat === 0 && lng === 0) return null;
  return { lat, lng };
};

export const googleMapsPinUrl = (coords) => {
  if (!coords) return null;
  return `https://www.google.com/maps?q=${coords.lat},${coords.lng}`;
};

/* Without an origin Google starts from the viewer's own location -- what a delivery partner wants. */
export const googleMapsDirectionsUrl = (origin, destination) => {
  if (!destination) return null;
  const from = origin ? `&origin=${origin.lat},${origin.lng}` : '';
  return `https://www.google.com/maps/dir/?api=1${from}&destination=${destination.lat},${destination.lng}&travelmode=driving`;
};
